// extracted by mini-css-extract-plugin
export default {"container":"DatePickerForm_container__9-H29","label":"DatePickerForm_label__s5tJk","datepicker":"DatePickerForm_datepicker__uZpay","error":"DatePickerForm_error__kuT4z"};